(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-image-counter"] && !Shopify.designMode) return;
  try {
    
(function(){
  var wrap = document.querySelector('#shopify-section-header .header__wrapper');
  var header = document.querySelector('#shopify-section-header .theme__header');

  function setBackfill(){
    var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--menu-backfill-height', h+'px');
  }
  function forceTransparent(){
    if (wrap && wrap.getAttribute('data-header-transparent') !== 'true'){
      wrap.setAttribute('data-header-transparent','true');
    }
  }

  setBackfill();
  forceTransparent();
  window.addEventListener('resize', setBackfill);

  if (wrap){
    new MutationObserver(forceTransparent).observe(wrap, {attributes:true, attributeFilter:['data-header-transparent']});
  }
})();

(function() {
  /* ----------------- COUNTDOWN ----------------- */
  function initCountdown(root) {
    if (!root || root.dataset.dicInit === '1') return;
    root.dataset.dicInit = '1';

    var mode = root.getAttribute('data-mode') || 'fixed';
    var isoFixed = (root.getAttribute('data-target') || '').trim();
    var localStr = (root.getAttribute('data-target-local') || '').trim();
    var timer = root.querySelector('.dic__timer');
    var hintEl = root.querySelector('.dic__datetime-hint');
    var notifyCta = root.querySelector('.dic__cta');
    var endedCta  = root.querySelector('.dic__ended-cta');

    var nums = {
      days: root.querySelector('[data-unit="days"]'),
      hours: root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]')
    };

    function pad2(n) { n = Math.floor(Math.abs(n)); return n < 10 ? '0' + n : String(n); }

    function parseFixedManual(s) {
      if (!s) return null;
      s = s.replace(' ', 'T');
      var m = s.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d+))?(Z|[+-]\d{2}:?\d{2})$/);
      if (!m) return null;
      var Y = +m[1], Mo = +m[2]-1, D = +m[3], H = +m[4], Mi = +m[5], S = +(m[6]||0);
      var tz = m[8];
      var offMin = 0;
      if (tz !== 'Z') {
        var sign = tz[0] === '-' ? -1 : 1;
        var hh = +tz.slice(1,3);
        var mm = +tz.slice(-2);
        offMin = sign * (hh*60 + mm);
      }
      var utc = Date.UTC(Y, Mo, D, H - Math.trunc(offMin/60), Mi - (offMin % 60), S);
      return new Date(utc);
    }

    function parseLocalManual(s) {
      if (!s) return null;
      s = s.replace(' ', 'T');
      var m = s.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/);
      if (!m) return null;
      var Y = +m[1], Mo = +m[2]-1, D = +m[3], H = +m[4], Mi = +m[5], S = +(m[6]||0);
      return new Date(Y, Mo, D, H, Mi, S);
    }

    var targetDate = (mode === 'local') ? parseLocalManual(localStr) : parseFixedManual(isoFixed);

    function renderHint() {
      if (!hintEl || !targetDate) return;
      var prefix = hintEl.getAttribute('data-hint-prefix') || '';
      try {
        var df = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short', timeZoneName: 'short' });
        hintEl.textContent = prefix + ' ' + df.format(targetDate) + (mode === 'local' ? ' (heure locale)' : '');
      } catch (e) {
        hintEl.textContent = prefix + ' ' + targetDate.toLocaleString();
      }
    }

    function update() {
      if (!targetDate || !timer) return;
      var now = new Date();
      var diff = targetDate - now;

      if (diff <= 0) {
        nums.days.textContent = '00';
        nums.hours.textContent = '00';
        nums.minutes.textContent = '00';
        nums.seconds.textContent = '00';

        if (timer) timer.setAttribute('hidden', '');
        if (notifyCta) notifyCta.setAttribute('hidden', '');
        if (endedCta) endedCta.removeAttribute('hidden');
        return;
      }

      var totalSecs = Math.floor(diff / 1000);
      var days = Math.floor(totalSecs / 86400);
      var hours = Math.floor((totalSecs % 86400) / 3600);
      var mins = Math.floor((totalSecs % 3600) / 60);
      var secs = totalSecs % 60;

      nums.days.textContent = String(days).padStart(2, '0');
      nums.hours.textContent = pad2(hours);
      nums.minutes.textContent = pad2(mins);
      nums.seconds.textContent = pad2(secs);
    }

    if (!targetDate || isNaN(targetDate.getTime())) {
      if (hintEl) hintEl.textContent = 'Date invalide. Exemple: 2025-11-18T18:00:00+01:00';
      return;
    }

    renderHint();
    update();

    var intId = setInterval(function() {
      update();
      if (timer && timer.hasAttribute('hidden')) clearInterval(intId);
    }, 1000);

    document.addEventListener('shopify:section:unload', function(e){
      if (e.target && e.target.contains(root)) {
        clearInterval(intId);
        root.dataset.dicInit = '';
      }
    });
  }

  function bootAll() {
    document.querySelectorAll('.drop-image-counter').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('.drop-image-counter');
    if (el) initCountdown(el);
  });
  document.addEventListener('shopify:section:select', function(e){
    var el = e.target.querySelector('.drop-image-counter');
    if (el) initCountdown(el);
  });

  /* --------------- FORM DIRECT (Brevo) --------------- */
  function initBrevoForms(scope){
    (scope || document).querySelectorAll('.drop-image-counter .dic__cta form.dic__form').forEach(function(form){
      if (form.dataset.dicBrevoInit === '1') return;
      form.dataset.dicBrevoInit = '1';

      var input = form.querySelector('.dic__input');
      var msg   = form.querySelector('.dic__msg');
      var frameName = form.getAttribute('target');
      var frame = frameName ? (form.parentElement.querySelector('iframe[name="'+frameName+'"]')) : null;

      var successText = (form.getAttribute('data-success-text') || "Thanks, you’re on the list.").trim();
      var errorText   = (form.getAttribute('data-error-text') || 'Adresse e-mail invalide.').trim();

      function isValidEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v||'').trim()); }

      form.addEventListener('submit', function(ev){
        if (!input || !msg) return;

        input.classList.remove('is-error');
        msg.textContent = '';
        msg.className = 'dic__msg';

        if (!isValidEmail(input.value)){
          ev.preventDefault();
          input.classList.add('is-error');
          msg.textContent = errorText;
          msg.className = 'dic__msg dic__msg--err';
          input.focus();
          return;
        }

        var submitBtn = form.querySelector('.dic__submit');
        if (submitBtn) submitBtn.setAttribute('disabled','disabled');
      });

      if (frame){
        frame.addEventListener('load', function(){
          var ok = document.createElement('span');
          ok.className = 'dic__msg dic__msg--ok';
          ok.textContent = successText;
          form.innerHTML = '';
          form.appendChild(ok);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initBrevoForms(document); });
  } else {
    initBrevoForms(document);
  }

  document.addEventListener('shopify:section:load', function(e){
    initBrevoForms(e.target);
  });
  document.addEventListener('shopify:section:select', function(e){
    initBrevoForms(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-video-counter"] && !Shopify.designMode) return;
  try {
    
(function(){
  var wrap = document.querySelector('#shopify-section-header .header__wrapper');
  var header = document.querySelector('#shopify-section-header .theme__header');

  function setBackfill(){
    var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--menu-backfill-height', h+'px');
  }
  function forceTransparent(){
    if (wrap && wrap.getAttribute('data-header-transparent') !== 'true'){
      wrap.setAttribute('data-header-transparent','true');
    }
  }

  setBackfill();
  forceTransparent();
  window.addEventListener('resize', setBackfill);

  if (wrap){
    new MutationObserver(forceTransparent).observe(wrap, {attributes:true, attributeFilter:['data-header-transparent']});
  }
})();

(function() {

  /* --- video autoplay (pattern proche thème: data-video-autoplay) --- */
  function forceAutoplay(scope){
    (scope || document).querySelectorAll('.drop-video-counter video[data-video-autoplay]').forEach(function(v){
      v.removeAttribute('controls');
      v.controls = false;

      v.setAttribute('playsinline','');
      v.setAttribute('muted','');
      v.muted = true;

      var p = v.play();
      if (p && typeof p.catch === 'function') { p.catch(function(){}); }
    });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ forceAutoplay(document); });
  } else {
    forceAutoplay(document);
  }
  document.addEventListener('shopify:section:load', function(e){ forceAutoplay(e.target); });
  document.addEventListener('shopify:section:select', function(e){ forceAutoplay(e.target); });

  /* ----------------- COUNTDOWN ----------------- */
  function initCountdown(root) {
    if (!root || root.dataset.dvcInit === '1') return;
    root.dataset.dvcInit = '1';

    if (root.classList.contains('is-video-only')) return;

    var mode = root.getAttribute('data-mode') || 'fixed';
    var isoFixed = (root.getAttribute('data-target') || '').trim();
    var localStr = (root.getAttribute('data-target-local') || '').trim();
    var timer = root.querySelector('.dvc__timer');
    var hintEl = root.querySelector('.dvc__datetime-hint');
    var notifyCta = root.querySelector('.dvc__cta');
    var endedCta  = root.querySelector('.dvc__ended-cta');

    var nums = {
      days: root.querySelector('[data-unit="days"]'),
      hours: root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]')
    };

    function pad2(n) { n = Math.floor(Math.abs(n)); return n < 10 ? '0' + n : String(n); }

    function parseFixedManual(s) {
      if (!s) return null;
      s = s.replace(' ', 'T');
      var m = s.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d+))?(Z|[+-]\d{2}:?\d{2})$/);
      if (!m) return null;
      var Y = +m[1], Mo = +m[2]-1, D = +m[3], H = +m[4], Mi = +m[5], S = +(m[6]||0);
      var tz = m[8];
      var offMin = 0;
      if (tz !== 'Z') {
        var sign = tz[0] === '-' ? -1 : 1;
        var hh = +tz.slice(1,3);
        var mm = +tz.slice(-2);
        offMin = sign * (hh*60 + mm);
      }
      var utc = Date.UTC(Y, Mo, D, H - Math.trunc(offMin/60), Mi - (offMin % 60), S);
      return new Date(utc);
    }

    function parseLocalManual(s) {
      if (!s) return null;
      s = s.replace(' ', 'T');
      var m = s.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/);
      if (!m) return null;
      var Y = +m[1], Mo = +m[2]-1, D = +m[3], H = +m[4], Mi = +m[5], S = +(m[6]||0);
      return new Date(Y, Mo, D, H, Mi, S);
    }

    var targetDate = (mode === 'local') ? parseLocalManual(localStr) : parseFixedManual(isoFixed);

    function renderHint() {
      if (!hintEl || !targetDate) return;
      var prefix = hintEl.getAttribute('data-hint-prefix') || '';
      try {
        var df = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short', timeZoneName: 'short' });
        hintEl.textContent = prefix + ' ' + df.format(targetDate) + (mode === 'local' ? ' (heure locale)' : '');
      } catch (e) {
        hintEl.textContent = prefix + ' ' + targetDate.toLocaleString();
      }
    }

    function update() {
      if (!targetDate || !timer) return;
      var now = new Date();
      var diff = targetDate - now;

      if (diff <= 0) {
        nums.days.textContent = '00';
        nums.hours.textContent = '00';
        nums.minutes.textContent = '00';
        nums.seconds.textContent = '00';

        if (timer) timer.setAttribute('hidden', '');
        if (notifyCta) notifyCta.setAttribute('hidden', '');
        if (endedCta) endedCta.removeAttribute('hidden');
        return;
      }

      var totalSecs = Math.floor(diff / 1000);
      var days = Math.floor(totalSecs / 86400);
      var hours = Math.floor((totalSecs % 86400) / 3600);
      var mins = Math.floor((totalSecs % 3600) / 60);
      var secs = totalSecs % 60;

      nums.days.textContent = String(days).padStart(2, '0');
      nums.hours.textContent = pad2(hours);
      nums.minutes.textContent = pad2(mins);
      nums.seconds.textContent = pad2(secs);
    }

    if (!targetDate || isNaN(targetDate.getTime())) {
      if (hintEl) hintEl.textContent = 'Date invalide. Exemple: 2025-11-18T18:00:00+01:00';
      return;
    }

    renderHint();
    update();
    var intId = setInterval(function() {
      update();
      if (timer && timer.hasAttribute('hidden')) clearInterval(intId);
    }, 1000);

    document.addEventListener('shopify:section:unload', function(e){
      if (e.target && e.target.contains(root)) {
        clearInterval(intId);
        root.dataset.dvcInit = '';
      }
    });
  }

  function bootAll() {
    document.querySelectorAll('.drop-video-counter').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('.drop-video-counter');
    if (el) initCountdown(el);
  });
  document.addEventListener('shopify:section:select', function(e){
    var el = e.target.querySelector('.drop-video-counter');
    if (el) initCountdown(el);
  });

  /* --------------- CTA -> INPUT (Brevo) --------------- */
  function swapToInput(cta, sectionEl){
    if (!cta || cta.dataset.state === 'input') return;
    cta.dataset.state = 'input';

    var action = (sectionEl.getAttribute('data-brevo-action') || '').trim();
    var locale      = (sectionEl.getAttribute('data-brevo-locale') || 'fr').trim();
    var successText = (sectionEl.getAttribute('data-success-text') || "Thanks, you’re on the list.").trim();
    var errorText   = (sectionEl.getAttribute('data-error-text')   || 'Adresse e-mail invalide.').trim();

    var id = 'dvc-email-' + (sectionEl && sectionEl.id ? sectionEl.id : Math.random().toString(36).slice(2));
    var iframeName = 'dvc-frame-' + (sectionEl && sectionEl.id ? sectionEl.id : Math.random().toString(36).slice(2));

    cta.innerHTML =
      '<form class="dvc__form has-button" method="POST" action="'+action+'" accept-charset="UTF-8" target="'+iframeName+'" novalidate>' +
        '<input type="hidden" name="locale" value="'+locale+'">' +
        '<input type="text" name="email_address_check" value="" class="input--hidden" tabindex="-1" aria-hidden="true" style="position:absolute;left:-9999px;">' +
        '<input type="hidden" name="OPT_IN" value="1">' +
        '<label class="sr-only" for="'+id+'">Email</label>' +
        '<input id="'+id+'" type="email" class="dvc__input" name="EMAIL" placeholder="Enter your email" inputmode="email" autocomplete="email" required>' +
        '<button class="dvc__submit" type="submit" aria-label="Submit">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M7.3 4.3a1 1 0 0 0 0 1.4L11.6 10l-4.3 4.3a1 1 0 1 0 1.4 1.4l5-5a1 1 0 0 0 0-1.4l-5-5a1 1 0 0 0-1.4 0z"/></svg>' +
        '</button>' +
        '<div class="dvc__msg" aria-live="polite"></div>' +
      '</form>' +
      '<iframe name="'+iframeName+'" style="display:none" tabindex="-1" aria-hidden="true"></iframe>';

    var form  = cta.querySelector('form');
    var input = cta.querySelector('#'+id);
    var msg   = cta.querySelector('.dvc__msg');
    if (input) input.focus();

    function isValidEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v||'').trim()); }

    form.addEventListener('submit', function(ev){
      input.classList.remove('is-error');
      msg.textContent = '';
      msg.className = 'dvc__msg';

      if (!isValidEmail(input.value)){
        ev.preventDefault();
        input.classList.add('is-error');
        msg.textContent = errorText || 'Adresse e-mail invalide.';
        msg.className = 'dvc__msg dvc__msg--err';
        input.focus();
        return;
      }
      var submitBtn = form.querySelector('.dvc__submit');
      if (submitBtn) submitBtn.setAttribute('disabled','disabled');
    });

    var frame = cta.querySelector('iframe[name="'+iframeName+'"]');
    if (frame){
      frame.addEventListener('load', function(){
        if (!form) return;
        var ok = document.createElement('span');
        ok.className = 'dvc__msg dvc__msg--ok';
        ok.textContent = successText || "Thanks, you’re on the list.";
        form.innerHTML = '';
        form.appendChild(ok);
      });
    }
  }

  function onClick(e){
    var btn = e.target.closest('.dvc__button');
    if (!btn) return;
    var sectionEl = btn.closest('.drop-video-counter');
    if (!sectionEl) return;
    var cta = btn.closest('.dvc__cta');
    if (!cta) return;
    e.preventDefault();
    e.stopPropagation();
    swapToInput(cta, sectionEl);
  }

  document.addEventListener('click', onClick);

  document.addEventListener('shopify:section:unload', function(ev){
    if (ev.target.querySelector('.drop-video-counter')) {
      document.removeEventListener('click', onClick);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
